import styled from "styled-components";

export const Container = styled.div`
width: 100%;



`;

export const ItemDiv = styled.div`
    
    display: flex;
    position: relative;
    transition: 0.5s all;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
   nav{
    transition: 0.5s all;
        background-color:   #091f7554 !important;
        backdrop-filter : blur(20px);
        gap: 10px;
        border-radius: 10px;
        font-size: 14px;
        border: 2px solid #ff011e00;

        display: flex ;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 5px;
        flex-direction: column;

        padding: 30px;
        max-width:480px;
        width: 100%;

        p{
            color: #fff !important;
            font-size: 14px !important;
        }
   }
    &:hover{
      
>div{
    box-shadow: 0px 0px 25px  rgba(0,250,0,0.9) !important;
}
        >h2{
            border-color:  rgb(0,250,0) !important;
        }
    }

>div{
    transition: 0.5s all;
    align-self: flex-start;
    margin-left: -20px;
    margin-bottom: -10px;
    font-weight: bold;
    background-color:  rgb(0,250,0) !important;
box-shadow: 0px 0px 15px  rgba(0,250,0,0.7) !important;
    backdrop-filter : blur(11px);
    font-size: 28px;
    color: rgb(2, 28, 60);
    display: flex ;
    align-items: center;
    justify-content: center;
    padding: 10px;
    width: 60px;
    height: 60px;
    border-radius: 10px;
}
    h2{  color: #fff;
        
    }


`